import './header.styles.scss';

const Header = () => {
  return (
    <div className='header'>
      <div className='header-logo'></div>
      <div className='txt-header'>
        <p className='first-txt'>Check my latest projects.</p>
        <div className='second-txt-container'>
          <p className='second-txt'>
            I know the price of success: dedication, hard work
          </p>
          <p className='second-txt'>
            and an unremitting devotion to the things
          </p>
          <p className='second-txt'>you want to see happen.</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
